var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "hx-to-create-template",
      attrs: {
        width: "600px",
        title: _vm.title,
        visible: _vm.dialogVisible,
        "close-on-click-modal": false,
        "show-close": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.resetDialogForm,
      },
    },
    [
      _c(
        "div",
        [
          _c(
            "el-form",
            {
              ref: "dialogForm",
              attrs: {
                model: _vm.itemParams,
                rules: _vm.checkItemParams,
                "label-width": "140px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "供应点名称 ：", prop: "title" } },
                [
                  _c("el-input", {
                    attrs: { size: "small", placeholder: "请输入供应点名称" },
                    model: {
                      value: _vm.itemParams.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.itemParams, "title", $$v)
                      },
                      expression: "itemParams.title",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "供应点区域 ：", prop: "title" } },
                [
                  _c("areaCascader", {
                    attrs: { checkStrictly: false },
                    on: { changeFull: _vm.handleAreaValues },
                    model: {
                      value: _vm.areaValues,
                      callback: function ($$v) {
                        _vm.areaValues = $$v
                      },
                      expression: "areaValues",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "联系人姓名 ：", prop: "contactName" } },
                [
                  _c("el-input", {
                    attrs: { size: "small", placeholder: "请输入联系人姓名" },
                    model: {
                      value: _vm.itemParams.contactName,
                      callback: function ($$v) {
                        _vm.$set(_vm.itemParams, "contactName", $$v)
                      },
                      expression: "itemParams.contactName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "联系人手机号 ：", prop: "contactMobile" } },
                [
                  _c("el-input", {
                    attrs: { size: "small", placeholder: "请输入联系人手机号" },
                    model: {
                      value: _vm.itemParams.contactMobile,
                      callback: function ($$v) {
                        _vm.$set(_vm.itemParams, "contactMobile", $$v)
                      },
                      expression: "itemParams.contactMobile",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "详细地址 ：", prop: "detailInfo" } },
                [
                  _c("el-input", {
                    attrs: { size: "small", placeholder: "请输入详细地址" },
                    model: {
                      value: _vm.itemParams.detailInfo,
                      callback: function ($$v) {
                        _vm.$set(_vm.itemParams, "detailInfo", $$v)
                      },
                      expression: "itemParams.detailInfo",
                    },
                  }),
                ],
                1
              ),
              _c("el-form-item", { attrs: { label: "供应点地址 ：" } }, [
                _c("p", [_vm._v(_vm._s(_vm.getAdress))]),
              ]),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: _vm.isDisabled,
                        size: "small",
                        type: "primary",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.saveSupplyCentre("dialogForm")
                        },
                      },
                    },
                    [_vm._v(" 保 存 ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: { click: _vm.resetDialogForm },
                    },
                    [_vm._v(" 取 消 ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }